const articleTypesWithNoHeaderImage = [
  "ARTICLE_MAP",
  "ARTICLE_PHOTO",
  "ARTICLE_INFOGRAPHIC",
  "ARTICLE_POEM",
];

/**
 * Check if content with specific type should display a header image
 * @param {String} articleType article type
 * @return {Boolean}
 */
export const articleHasHeaderImage = (content) => {
  return content?.header_image
    ? !articleTypesWithNoHeaderImage.includes(content?.article_type)
    : null;
};
